import { Skeleton } from 'primereact';
import {SvgComponent} from "../SvgComponent/SvgComponent";
import parse from 'html-react-parser';
import './Tarjetas.styles.css'
import {useState, useRef, useLayoutEffect,useEffect} from "react";

const MARGIN = 10;
export const Tarjetas = ({Tarjetas, SimboloMoneda}) => {
    return (
        <div className="card_row">
            {Tarjetas.map((tarjeta, index) => <Tarjeta key={index} tarjeta={tarjeta} SimboloMoneda={SimboloMoneda} esMultiple={false}/>)}
        </div>
    );
}
export const TarjetasMultiple = ({ TarjetasMultiple, SimboloMoneda }) => {
    return (
        <div className="card_row">
            {TarjetasMultiple.map((tarjeta, index) => <Tarjeta key={index} tarjeta={tarjeta} SimboloMoneda={SimboloMoneda} esMultiple={true} index={index}/> )}
        </div>
    );
}

const Tarjeta = ({tarjeta,SimboloMoneda, esMultiple, index}) => {
    const [showHoverBox, setShowHoverBox] = useState(false);
    const triggerRectRef = useRef(null);
    const [hoverBoxPosition, setHoverBoxPosition] = useState({ top: 0, left: 0 });
    const hoverBoxRef = useRef(null);
    const hoverTimeout = useRef(null);
    const componentRef = useRef(null);
    const isNumericWithDecimals = (value) => {
        const regex = /^-?\d+\.\d+$/;
        return regex.test(value);
    }

    useEffect(() => {
        const handleMouseMove = (event) => {
            const card = componentRef.current;
            const hover = hoverBoxRef.current;

            if (
                card &&
                hover &&
                !card.contains(event.target) &&
                !hover.contains(event.target)
            ) {
                setShowHoverBox(false);
            }
        };

        if (showHoverBox) {
            document.addEventListener("mousemove", handleMouseMove);
        }

        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, [showHoverBox]);
    useLayoutEffect(() => {
        if (!showHoverBox || !hoverBoxRef.current || !triggerRectRef.current)
            return;

        const boxRect = hoverBoxRef.current.getBoundingClientRect();
        const rect = triggerRectRef.current;

        let left = rect.right;
        if (rect.right + boxRect.width + MARGIN > window.innerWidth) {
            left = rect.left - boxRect.width;
        }
        left = Math.min(
            Math.max(left, MARGIN),
            window.innerWidth - boxRect.width - MARGIN
        );

        let top = rect.top;

        if (rect.top + boxRect.height + MARGIN > window.innerHeight) {
            top = rect.bottom;
        }

        top = Math.min(
            Math.max(top, MARGIN),
            window.innerHeight - boxRect.height - MARGIN
        );

        setHoverBoxPosition({ top, left });
    }, [showHoverBox]);
    return (
        esMultiple ? 
            (
                <div className="draggable" draggable="true" data-id={index + 1} style={{ marginBottom: '20px', marginRight: '10px' }}>
                    <div className="tarjetas">
                        <div style={{ fontWeight: 'bolder', margin: '10px', marginLeft: '20px', fontSize: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {tarjeta.Titulo}
                            <div style={{ marginRight: '10px' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" fill="red" viewBox="0 0 24 24">
                                    {parse(tarjeta.SVG)}
                                </svg>
                            </div>
                        </div>
                        <hr style={{ margin: '0' }} />

                        <div className="card-stats" style={{ paddingTop: '0' }}>
                            <div className="card">
                                <div className="card-body" style={{ padding: '15px 15px 0px 0px' }}>
                                    <div className="card_row" style={{ justifyContent: 'space-between' }}>
                                        {/* Iterating over tarjeta.Tarjetas */}
                                        <div className="col-xs-7">
                                            <div className="numbers" style={{ textAlign: 'left', width: '135px' }}>
                                                <p className="card-category" style={{ color: 'lightslategray', marginBottom: '0', marginTop: '0', fontSize: '12px', fontWeight: '400' }}>{tarjeta.Tarjetas[0].Titulo}</p>
                                                <h4 className="card-title" style={{ margin: '0', textAlign: 'left', fontSize: '14.6px' }}>{tarjeta.Tarjetas[0].DatoDesc}</h4>
                                            </div>
                                            <div className="numbers" style={{ textAlign: 'left', width: '135px' }}>
                                                <p className="card-category" style={{ color: 'lightslategray', marginBottom: '0', marginTop: '0', fontSize: '12px', fontWeight: '400' }}>{tarjeta.Tarjetas[1].Titulo}</p>
                                                <h4 className="card-title" style={{ margin: '0', textAlign: 'left', fontSize: '14.6px' }}>{`${SimboloMoneda} ${tarjeta.Tarjetas[1].DatoDesc}`}</h4>
                                            </div>
                                        </div>
                                        <div className="col-xs-7">
                                            <div className="numbers" style={{ textAlign: 'left', width: '135px' }}>
                                                <p className="card-category" style={{ color: 'lightslategray', marginBottom: '0', marginTop: '0', fontSize: '12px', fontWeight: '400' }}>{tarjeta.Tarjetas[2].Titulo}</p>
                                                <h4 className="card-title" style={{ margin: '0', textAlign: 'left', fontSize: '14.6px' }}>{`${SimboloMoneda} ${tarjeta.Tarjetas[2].DatoDesc}`}</h4>
                                            </div>
                                            {tarjeta.Tarjetas.length > 3 && (
                                                <div className="numbers" style={{ textAlign: 'left', width: '135px' }}>
                                                    <p className="card-category" style={{ color: 'lightslategray', marginBottom: '0', marginTop: '0', fontSize: '12px', fontWeight: '400' }}>{tarjeta.Tarjetas[3].Titulo}</p>
                                                    <h4 className="card-title" style={{ margin: '0', textAlign: 'left', fontSize: '14.6px' }}>{tarjeta.Tarjetas[3].DatoDesc}</h4>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <hr />
                                    <div className="stats" style={{ color: '#a9a9a9' }}>
                                        {tarjeta.PeriodDesc}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : 
            (
                <div className="draggable" draggable="true" style={{ marginBottom: '20px', marginRight: '10px' }}>
                    <div className="tarjetas">
                        <div className="card-stats">
                            <div className="card">
                                <div className="card-body" style={{ padding: '5px 5px 0' }}>
                                    <div className="card_row" style={{   display: 'flex',  justifyContent: 'space-between',  marginRight: 0, flexWrap: 'nowrap'}}>
                                        <div className="col-xs-5">
                                            <div style={{ fontSize: '2rem', minHeight: '64px'}}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem" fill="red" viewBox="0 0 24 24">
                                                    {parse(tarjeta.SVG)}
                                                </svg>
                                            </div>
                                        </div>
                                        <div className="col-xs-7">
                                            <div className="numbers" style={{textAlign: 'right'}}>
                                                <p className="card-category" style={{ marginBottom: '5px', fontSize: '14px', fontWeight: 400 }}>{tarjeta.Titulo}</p>
                                                {isNumericWithDecimals(tarjeta.DatoDesc) ? (
                                                    <h4 className="card-title" style={{ margin: 0, maxWidth: 'none' }}> {SimboloMoneda} {Citrus.Convert.toCurrencyNoSimbolo(tarjeta.DatoDesc)}</h4>
                                                ) : (
                                                    <h4 className="card-title" style={{ margin: 0, maxWidth: 'none' }}> {tarjeta.DatoDesc}</h4>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <hr/>
                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <div className="stats" style={{color: '#a9a9a9'}}>
                                            {tarjeta.PeriodDesc}
                                        </div>
                                        <div
                                            ref={componentRef}
                                            onMouseEnter={(e) => {
                                                const rect = e.currentTarget.getBoundingClientRect();
                                                triggerRectRef.current = rect;

                                                setHoverBoxPosition({ top: rect.bottom, left: rect.right });
                                                hoverTimeout.current = setTimeout(() => {
                                                    setShowHoverBox(true);
                                                }, 500);
                                            }}
                                            onMouseLeave={() => {
                                                clearTimeout(hoverTimeout.current);
                                                setShowHoverBox(false);
                                            }}
                                        >
                                            {(showHoverBox && tarjeta.Descripcion) && (
                                                <div
                                                    ref={hoverBoxRef}
                                                    style={{
                                                        position: "fixed",
                                                        top: hoverBoxPosition.top,
                                                        left: hoverBoxPosition.left,
                                                        overflowY: "auto",
                                                        backgroundColor: "#fff",
                                                        borderRadius: "6px",
                                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                                        padding: "10px",
                                                        zIndex: 9999,
                                                        overflowWrap: "break-word",
                                                        wordBreak: "break-word",
                                                        whiteSpace: "normal",
                                                        overflow: "hidden",
                                                        minWidth: "300px",
                                                        maxWidth: "1000px",
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    <p style={{margin:0}}>Formula: <span style={{color:"#a9a9a9", fontSize:'10px'}}>{tarjeta.Descripcion}</span></p>
                                                </div>
                                            )}
                                            <SvgComponent iconName='info' fill='#a9a9a9' width='20' height='20' >
                                            </SvgComponent>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
    )
}
export const TarjetasSkeleton = () => {
    return (
        <div className="draggable" draggable="true" style={{ marginBottom: '20px', marginRight: '10px' }}>
            <div className="tarjetas">
                <div className="card-stats">
                    <div className="card">
                        <div className="card-body" style={{ padding: '5px 5px 0' }}>
                            <div className="card_row" style={{   display: 'flex',  justifyContent: 'space-between',  marginRight: 0}}>
                                <div className="col-xs-5">
                                    <div style={{ fontSize: '2rem', minHeight: '64px'}}>
                                        <Skeleton
                                            width='48px'
                                            height='48px'
                                        >
                                        </Skeleton>
                                    </div>
                                </div>
                                <div className="col-xs-7">
                                    <div className="numbers" style={{textAlign: 'right'}}>
                                        <p className="card-category" style={{ marginBottom: '5px', fontSize: '14px', fontWeight: 400 }}><Skeleton width='100px'> </Skeleton></p>
                                        <h4 className="card-title"  style={{ margin: 0, maxWidth: 'none', display: 'flex', contentAlign: 'rigth', justifyContent: 'right' }}><Skeleton width='75px'> </Skeleton></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <hr/>
                            <div className="stats" style={{color: '#a9a9a9'}}>
                                <Skeleton width='50px'> </Skeleton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export const TarjetasMultipleSkeleton = () => {
    return (
        <div className="draggable" draggable="true" style={{ marginBottom: '20px', marginRight: '10px' }}>
            <div className="tarjetas">
                <div style={{ fontWeight: 'bolder', margin: '10px', marginLeft: '20px', fontSize: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Skeleton width='130px'> </Skeleton>
                    <div style={{ marginRight: '10px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" fill="red" viewBox="0 0 24 24">
                            <Skeleton width='30px' height='30px'> </Skeleton>
                        </svg>
                    </div>
                </div>
                <hr style={{ margin: '0' }} />

                <div className="card-stats" style={{ paddingTop: '0' }}>
                    <div className="card">
                        <div className="card-body" style={{ padding: '15px 15px 0px 0px' }}>
                            <div className="card_row" style={{ justifyContent: 'space-between' }}>
                                {/* Iterating over tarjeta.Tarjetas */}
                                <div className="col-xs-7">
                                    <div className="numbers" style={{ textAlign: 'left', width: '135px' }}>
                                        <p className="card-category" style={{ color: 'lightslategray', marginBottom: '3px', marginTop: '0', fontSize: '12px', fontWeight: '400' }}><Skeleton width='30px' height='6px'> </Skeleton></p>
                                        <h4 className="card-title" style={{ margin: '0', textAlign: 'left', fontSize: '14.6px' }}><Skeleton width='85px' height='15px' > </Skeleton></h4>
                                    </div>
                                    <div className="numbers" style={{ textAlign: 'left', width: '135px' }}>
                                        <p className="card-category" style={{ color: 'lightslategray', marginBottom: '3px', marginTop: '3px', fontSize: '12px', fontWeight: '400' }}><Skeleton width='30px' height='6px'> </Skeleton></p>
                                        <h4 className="card-title" style={{ margin: '0', textAlign: 'left', fontSize: '14.6px' }}><Skeleton width='85px' height='15px' > </Skeleton></h4>
                                    </div>
                                </div>
                                <div className="col-xs-7">
                                    <div className="numbers" style={{ textAlign: 'left', width: '135px' }}>
                                        <p className="card-category" style={{ color: 'lightslategray', marginBottom: '3px', marginTop: '0', fontSize: '12px', fontWeight: '400' }}><Skeleton width='30px' height='6px'> </Skeleton></p>
                                        <h4 className="card-title" style={{ margin: '0', textAlign: 'left', fontSize: '14.6px' }}><Skeleton width='85px' height='15px' > </Skeleton></h4>
                                    </div>
                                    <div className="numbers" style={{ textAlign: 'left', width: '135px' }}>
                                        <p className="card-category" style={{ color: 'lightslategray', marginBottom: '3px', marginTop: '3px', fontSize: '12px', fontWeight: '400' }}><Skeleton width='30px' height='6px'> </Skeleton></p>
                                        <h4 className="card-title" style={{ margin: '0', textAlign: 'left', fontSize: '14.6px' }}><Skeleton width='85px' height='15px' > </Skeleton></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <hr />
                            <div className="stats" style={{ color: '#a9a9a9' }}>
                                <Skeleton width='50px'> </Skeleton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
